var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "observed-behavior" },
    _vm._l(_vm.visibleTypes, function(type) {
      return _c("div", { key: type, staticClass: "observed-behavior__row" }, [
        _c(
          "div",
          { staticClass: "observed-behavior__controls" },
          [
            _c("label", { staticClass: "observed-behavior__label" }, [
              _vm._v(_vm._s(_vm.typeTitle(type)) + ":")
            ]),
            !_vm.isReadOnly
              ? [
                  _c("validation-provider", {
                    attrs: {
                      rules: _vm.isSelectedPickerOther(type) ? "required" : ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-drop-down", {
                                attrs: {
                                  "custom-error-msg": "El campo es requerido",
                                  error: errors[0],
                                  fieldkey: "id",
                                  fieldname: "name",
                                  options: _vm.availableOptions(type),
                                  placeholder: "Seleccione"
                                },
                                model: {
                                  value: _vm.selectedByType[type].option,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.selectedByType[type],
                                      "option",
                                      $$v
                                    )
                                  },
                                  expression: "selectedByType[type].option"
                                }
                              }),
                              _vm.isSelectedPickerOther(type)
                                ? _c("custom-input", {
                                    staticClass: "mt-3",
                                    attrs: {
                                      "custom-error-msg":
                                        "El campo es requerido",
                                      error: errors[0],
                                      maxlength: "250",
                                      placeholder: "Especifique"
                                    },
                                    model: {
                                      value: _vm.selectedByType[type].other,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.selectedByType[type],
                                          "other",
                                          $$v
                                        )
                                      },
                                      expression: "selectedByType[type].other"
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _c(
                    "div",
                    { staticClass: "observed-behavior__actions" },
                    [
                      _c("action-button", {
                        attrs: {
                          i: "fas fa-file-plus",
                          text: "Añadir",
                          variant: "success"
                        },
                        on: {
                          click: function($event) {
                            return _vm.addOption(type)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.showOtherError(type)
                    ? _c("error", {
                        attrs: {
                          message: "Debe especificar la opción Otro.",
                          variant: "no-border"
                        }
                      })
                    : _vm._e(),
                  _vm.showOptionsError(type)
                    ? _c("error", {
                        attrs: {
                          message: "Debe seleccionar al menos uno.",
                          variant: "no-border"
                        }
                      })
                    : _vm._e()
                ]
              : _vm._e()
          ],
          2
        ),
        _c("div", { staticClass: "observed-behavior__selected" }, [
          _c(
            "span",
            { staticClass: "observed-behavior__selected-label text-muted" },
            [_vm._v(" Seleccionado(s): ")]
          ),
          _vm.selectedOptions(type).length
            ? _c(
                "div",
                { staticClass: "observed-behavior__chips" },
                _vm._l(_vm.selectedOptions(type), function(item) {
                  return _c(
                    "button",
                    {
                      key: item.id,
                      staticClass: "observed-behavior__chip",
                      attrs: { disabled: _vm.isReadOnly, type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.removeOption(item)
                        }
                      }
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.optionLabel(item)))]),
                      !_vm.isReadOnly
                        ? _c("i", { staticClass: "far fa-times-circle" })
                        : _vm._e()
                    ]
                  )
                }),
                0
              )
            : _c("span", { staticClass: "observed-behavior__empty" }, [
                _vm._v("-")
              ])
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }